import httpClient from "../../clients/httpClient";
import {
    IIntegration,
    IIntegrationPayload,
    IVerifyIntegrationCredentialsPayload,
    IVerifyIntegrationCredentialsResponse,
} from "../../interfaces/integration.interface";

export const getIntegrations = (service_type?: string, service?: string, include?: string) => {
    return httpClient.get<IIntegration[]>(`/api/v1/integrations`, {
        params: {
            service_type,
            service,
            include,
        },
    });
};

export const getIntegration = (id: string) => {
    return httpClient.get(`/api/v1/integrations/${id}`);
};

export const createIntegration = (payload: IIntegrationPayload) => {
    return httpClient.post("/api/v1/integrations", payload);
};

export const editIntegration = (id: number, payload: IIntegrationPayload) => {
    return httpClient.post(`/api/v1/integrations/${id}`, payload);
};

export const deleteIntegration = (id: number) => {
    return httpClient.delete(`/api/v1/integrations/${id}`);
};

export const getIntegrationTemplates = () => {
    return httpClient.get(`/api/v1/integration-templates`);
};

export const syncDeliveryZones = (id: number) => {
    return httpClient.post(`/api/v1/integrations/${id}/sync-delivery-zones`);
};

// Verifies a candidate credential payload against the vendor before any
// integration row is created/updated. Returns 200 with `data.passed` even when
// the vendor rejects the credentials — the boolean lives in the body. The cast
// reflects the response interceptor, which resolves with the response body
// rather than the raw AxiosResponse.
export const verifyIntegrationCredentialsRequest = (
    payload: IVerifyIntegrationCredentialsPayload
): Promise<IVerifyIntegrationCredentialsResponse> => {
    return httpClient.post(
        "/api/v1/integrations/verify-credentials",
        payload
    ) as unknown as Promise<IVerifyIntegrationCredentialsResponse>;
};
